import { render, staticRenderFns } from "./luckyWheelPage.vue?vue&type=template&id=1fd3c7f0&scoped=true"
import script from "./luckyWheelPage.vue?vue&type=script&lang=js"
export * from "./luckyWheelPage.vue?vue&type=script&lang=js"
import style0 from "./luckyWheelPage.vue?vue&type=style&index=0&id=1fd3c7f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3c7f0",
  null
  
)

export default component.exports